import type { ResponsiveValue, SpacingProps } from '@shopify/restyle';
import { createRestyleComponent, spacing, useResponsiveProp } from '@shopify/restyle';
import { group } from 'app/lib/array';
import type { ComponentProps, PropsWithChildren } from 'react';
import { Children, isValidElement } from 'react';

import { Column, Row } from './box';
import type { Theme } from 'app/shopify';

interface GridProps extends SpacingProps<Theme> {
  columnGap?: ResponsiveValue<keyof Theme['spacing'], Theme['breakpoints']>;
  columns: ResponsiveValue<number, Theme['breakpoints']>;
  gap?: ResponsiveValue<keyof Theme['spacing'], Theme['breakpoints']>;
  rowGap?: ResponsiveValue<keyof Theme['spacing'], Theme['breakpoints']>;
  rowJustify?: ResponsiveValue<
    'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly',
    Theme['breakpoints']
  >;
}

const BaseGrid = createRestyleComponent<ComponentProps<typeof Column>, Theme>([spacing], Column);

export function Grid({ children, columnGap, columns, gap, rowGap, rowJustify, ...rest }: PropsWithChildren<GridProps>) {
  const resolvedColumns = useResponsiveProp(columns)!;

  return (
    <BaseGrid gap={gap ?? columnGap} {...rest}>
      {group(resolvedColumns, Children.toArray(children)).map((row) => (
        <Row
          gap={gap ?? rowGap}
          justifyContent={rowJustify ?? 'space-evenly'}
          key={isValidElement(row[0]) ? row[0].key : undefined}
        >
          {row}
        </Row>
      ))}
    </BaseGrid>
  );
}
